class BFProductFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bfInitialized === 'true') return;

    this.dataset.bfInitialized = 'true';
    this.items = Array.from(this.querySelectorAll('[data-bf-product-faq-item]'));

    if (this.dataset.bfSingleOpen !== 'true') return;

    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        this.items.forEach((candidate) => {
          if (candidate !== item) candidate.open = false;
        });
      });
    });
  }
}

if (!customElements.get('bf-product-faq')) {
  customElements.define('bf-product-faq', BFProductFaq);
}
